import theme from '../../styles/theme';
export const sizes = {
    extraLarge: theme.spacing.x12,
    extraSmall: theme.spacing.x2,
    huge: theme.spacing.x16,
    large: theme.spacing.x8,
    small: theme.spacing.x3,
    tiny: theme.spacing.base,
};
